export default "__VITE_ASSET__4e3d47f3__"